var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"grid-list-md":""}},[_c('h2',{staticClass:"mt-3"},[_vm._v("Congratulations!")]),_c('p',{staticClass:"mt-2 mb-5",attrs:{"id":"detail"}},[_vm._v("\n  You'll now hear important updates from us via email.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Go to home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }